export type TableRowData = Record<string, unknown>;

export type SortDirection = 'asc' | 'desc';

export function toTableCellText(value: unknown, emptyPlaceholder = '—'): string {
  if (value === null || value === undefined) {
    return emptyPlaceholder;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed !== '' ? trimmed : emptyPlaceholder;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return String(value);
}

export function compareTableValues(a: unknown, b: unknown): number {
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }
  return toTableCellText(a).localeCompare(toTableCellText(b));
}

export function getRowKeyFromOptionalId(id: unknown, index: number, prefix = 'missing-id'): string {
  if (id === null || id === undefined) {
    return `${prefix}:${index}`;
  }
  const asString = String(id).trim();
  return asString !== '' ? asString : `${prefix}:${index}`;
}

export function getTableRowId(row: TableRowData, index: number): string {
  const id = row['id'];
  if (typeof id === 'string' && id.trim() !== '') {
    return id;
  }
  return String(index);
}

export function getTableColumnKeys(rows: readonly object[]): string[] {
  const keys = new Set<string>();
  for (const row of rows.slice(0, 50)) {
    for (const key of Object.keys(row as TableRowData)) {
      keys.add(key);
    }
  }
  return Array.from(keys).sort();
}

export function toTableSearchText(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map(toTableSearchText).join(' ');
  }
  return '';
}
